import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const VolumeDownIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "VolumeDown",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.58 2.13c-.2-.08-.42-.13-.66-.13-.49 0-.93.2-1.25.51L11.18 9H4.91c-.97 0-1.75.78-1.75 1.75v10.5c0 .97.78 1.75 1.75 1.75h6.27l6.49 6.49c.32.32.76.52 1.24.52.24 0 .47-.05.68-.14h-.01c.64-.27 1.08-.89 1.08-1.61V3.75c0-.73-.44-1.35-1.07-1.61h-.01Zm6.22 7.8c-.29-.22-.65-.35-1.05-.35-.97 0-1.75.78-1.75 1.75 0 .57.27 1.08.7 1.4.99.76 1.63 1.94 1.63 3.27s-.64 2.51-1.62 3.26h-.01c-.43.33-.7.84-.7 1.41 0 .97.78 1.75 1.75 1.75.4 0 .76-.13 1.05-.35 1.85-1.4 3.03-3.59 3.03-6.06s-1.18-4.67-3.01-6.05h-.02v-.01Z"
    })
  }));
};